module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='  <div class="spotlightWrapper">\n    <div id="spotlight">\n      <input class="typeahead" type="text" placeholder="Search... ">\n    </div>\n  </div>\n';
}
return __p;
};
